import { createSlice } from "@reduxjs/toolkit";
import { Feedback, Meta } from "src/store/types";
import { doFetchFeedbackList, doRemoveFeedback } from "./feedback.action";

interface feedbackState {
  feedbacks: Feedback[];
  meta: Meta | null;
  loading: boolean;
  error: string | null;
  searchQuery: string;
}

const initialState: feedbackState = {
  feedbacks: [] as Feedback[],
  meta: null,
  loading: false,
  error: null,
  searchQuery: "",
};

export const feedbackSlice = createSlice({
  name: "feedback",
  initialState,
  reducers: {
    setSearchQuery: (state, action) => {
      state.searchQuery = action.payload;
    },
    clearSearch: (state) => {
      state.searchQuery = "";
    },
  },
  extraReducers: (builder) => {
    // fetch feedback list
    builder
      .addCase(doFetchFeedbackList.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(doFetchFeedbackList.fulfilled, (state, action) => {
        state.loading = false;
        state.feedbacks = action.payload.data;
        state.meta = action.payload.meta;
      })
      .addCase(doFetchFeedbackList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });

    // remove feedback
    builder
      .addCase(doRemoveFeedback.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(doRemoveFeedback.fulfilled, (state, action) => {
        state.loading = false;
        // state.feedbacks = action.payload.data;
      })
      .addCase(doRemoveFeedback.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
  },
});

export default feedbackSlice.reducer;
